var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-btn',{staticClass:"text-caption",attrs:{"loading":_vm.loading,"rounded":"","x-small":"","text":""},domProps:{"textContent":_vm._s(`Like`)},on:{"click":_vm.likeComment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }